/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeDTO } from './AttributeDTO';
import {
    AttributeDTOFromJSON,
    AttributeDTOFromJSONTyped,
    AttributeDTOToJSON,
} from './AttributeDTO';

/**
 * 
 * @export
 * @interface EntryAttributesDTO
 */
export interface EntryAttributesDTO {
    /**
     * 
     * @type {Array<AttributeDTO>}
     * @memberof EntryAttributesDTO
     */
    attributes: Array<AttributeDTO>;
    /**
     * Deprecated internal run UUID; use runCustomId instead
     * @type {string}
     * @memberof EntryAttributesDTO
     */
    experimentId: string;
    /**
     * Run custom id
     * @type {string}
     * @memberof EntryAttributesDTO
     */
    runCustomId?: string;
}

/**
 * Check if a given object implements the EntryAttributesDTO interface.
 */
export function instanceOfEntryAttributesDTO(value: object): value is EntryAttributesDTO {
    if (!('attributes' in value) || value['attributes'] === undefined) return false;
    if (!('experimentId' in value) || value['experimentId'] === undefined) return false;
    return true;
}

export function EntryAttributesDTOFromJSON(json: any): EntryAttributesDTO {
    return EntryAttributesDTOFromJSONTyped(json, false);
}

export function EntryAttributesDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): EntryAttributesDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributes': ((json['attributes'] as Array<any>).map(AttributeDTOFromJSON)),
        'experimentId': json['experimentId'],
        'runCustomId': json['runCustomId'] == null ? undefined : json['runCustomId'],
    };
}

export function EntryAttributesDTOToJSON(value?: EntryAttributesDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributes': ((value['attributes'] as Array<any>).map(AttributeDTOToJSON)),
        'experimentId': value['experimentId'],
        'runCustomId': value['runCustomId'],
    };
}

